import * as React from 'react';
import OperatorBettingRulesENLazy from './EN/betting-rules-EN-lazy';

export const operatorBettingRulesComponents: Record<string, React.ComponentType<{}>> = {
    en: OperatorBettingRulesENLazy,
};